import { JSX } from 'react'

import { IconProps } from '../../icon'

const Error: (props: IconProps) => JSX.Element = ({
  dataTestId,
  fill,
  height,
  id,
  stroke,
  title,
  width,
}: IconProps) => (
  <svg
    data-testid={dataTestId}
    fill={fill}
    height={height || 48}
    id={id}
    stroke={stroke}
    viewBox='0 0 48 48'
    width={width || 48}
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>{title}</title>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M24 10.6667C16.6362 10.6667 10.6667 16.6362 10.6667 24C10.6667 31.3637 16.6362 37.3333 24 37.3333C31.3637 37.3333 37.3333 31.3637 37.3333 24C37.3333 16.6362 31.3637 10.6667 24 10.6667ZM8 24C8 15.1634 15.1634 8 24 8C32.8365 8 40 15.1634 40 24C40 32.8365 32.8365 40 24 40C15.1634 40 8 32.8365 8 24ZM24 17.3333C24.7364 17.3333 25.3333 17.9303 25.3333 18.6667V26.6667C25.3333 27.4031 24.7364 28 24 28C23.2636 28 22.6667 27.4031 22.6667 26.6667V18.6667C22.6667 17.9303 23.2636 17.3333 24 17.3333ZM24 29.3333C24.7364 29.3333 25.3333 29.9303 25.3333 30.6667V30.68C25.3333 31.4164 24.7364 32.0133 24 32.0133C23.2636 32.0133 22.6667 31.4164 22.6667 30.68V30.6667C22.6667 29.9303 23.2636 29.3333 24 29.3333Z'
      fill={fill}
    />
  </svg>
)

export default Error
